import React from 'react';
import CostcoLocationTemplate from '../../components/CostcoLocationTemplate';

const Casuarina = () => (
  <CostcoLocationTemplate
    warehouseName="Casuarina"
    suburb="Casuarina"
    state="Western Australia"
    stateShort="WA"
    address="Shorehaven Blvd, Casuarina WA 6167"
    path="/costco/casuarina"
    nearbySuburbs={[
      'Casuarina',
      'Wellard',
      'Baldivis',
      'Bertram',
      'Warnbro',
      'Rockingham',
      'Cooloongup',
      'Safety Bay',
      'Waikiki',
      'Port Kennedy',
    ]}
    description="Manage Your Loans is the exclusive Costco member loan partner serving the Casuarina warehouse and Perth's southern growth corridor. From new family homes in Baldivis and Wellard to established properties in Rockingham, our brokers understand the local market and can help you earn Costco Shop Card rewards on your settled loans."
    localContext={[
      'Perth\'s southern corridor — including Casuarina, Baldivis, and Wellard — is one of Western Australia\'s fastest-growing residential areas, with affordable new estates attracting young families and first home buyers.',
      'Rockingham and surrounding coastal suburbs offer a lifestyle-oriented property market with strong rental demand, making it popular for both owner-occupiers and investors.',
      'New suburbs like Casuarina and Shorehaven are delivering modern, master-planned communities with family-friendly amenities, driving consistent demand for construction and house-and-land packages.',
    ]}
    faqs={[
      {
        q: 'How do I earn a Costco Shop Card through the Casuarina warehouse?',
        a: 'Apply for a loan through Manage Your Loans as a Costco Executive Member. When your loan settles, you\'ll receive a Shop Card reward redeemable at the Casuarina warehouse or any Costco location in Australia.',
      },
      {
        q: 'Are there good first home buyer options in the southern Perth corridor?',
        a: 'Yes. Suburbs like Baldivis, Wellard, and Bertram offer affordable house-and-land packages well suited to first home buyers. Western Australia\'s First Home Owner Grant may also apply, and your Costco Shop Card reward adds further value.',
      },
      {
        q: 'Can I get a construction loan for a new build in Casuarina?',
        a: 'Absolutely. We work with lenders who offer construction loans for house-and-land packages in new estates. Our brokers can guide you through the staged drawdown process and help you maximise your Shop Card reward.',
      },
      {
        q: 'Which suburbs near Rockingham are covered?',
        a: 'We serve all suburbs in the southern Perth corridor including Casuarina, Wellard, Baldivis, Bertram, Warnbro, Rockingham, Cooloongup, Safety Bay, Waikiki, and Port Kennedy. Apply online from anywhere in WA.',
      },
    ]}
    suburbData={{
      suburb: 'Casuarina',
      medianHouse: '$550,000',
      medianUnit: '$370,000',
      daysOnMarket: '20 days',
      rentalYield: '4.6%',
      population: '3,500',
      distanceToCostco: '1 km',
    }}
    surroundingSuburbs={[
      { suburb: 'Wellard', medianHouse: '$520,000', medianUnit: '$350,000', daysOnMarket: '19 days' },
      { suburb: 'Baldivis', medianHouse: '$560,000', medianUnit: '$380,000', daysOnMarket: '18 days' },
      { suburb: 'Bertram', medianHouse: '$500,000', medianUnit: '$340,000', daysOnMarket: '20 days' },
      { suburb: 'Warnbro', medianHouse: '$530,000', medianUnit: '$360,000', daysOnMarket: '21 days' },
      { suburb: 'Rockingham', medianHouse: '$520,000', medianUnit: '$350,000', daysOnMarket: '19 days' },
      { suburb: 'Cooloongup', medianHouse: '$480,000', medianUnit: '$330,000', daysOnMarket: '22 days' },
      { suburb: 'Safety Bay', medianHouse: '$540,000', medianUnit: '$370,000', daysOnMarket: '20 days' },
      { suburb: 'Waikiki', medianHouse: '$510,000', medianUnit: '$340,000', daysOnMarket: '21 days' },
      { suburb: 'Port Kennedy', medianHouse: '$530,000', medianUnit: '$360,000', daysOnMarket: '19 days' },
    ]}
  />
);

export default Casuarina;
